import { API, GET, PUT } from '../middleware/api';
import { API_URL } from '../config';

// E-mail notification settings ("Ilmoitukset"). `portal` is the service the
// page is opened in: 'fleet', 'workshop' or 'chain'. `selection` is what the
// portal's top bar has selected, e.g. { organization_id: 5 } — the page shows
// and changes only that company / workshop / chain. `userId` is null for the
// logged-in user's own settings.

export function fetchNotificationSettingsUsers(portal, selection) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/notification_settings/users/`,
      types: [
        'FETCH_NOTIFICATION_SETTINGS_USERS_REQUEST',
        'FETCH_NOTIFICATION_SETTINGS_USERS_SUCCESS',
        'FETCH_NOTIFICATION_SETTINGS_USERS_FAIL',
      ],
      params: Object.assign({ portal }, selection),
      additionalData: { requestKey: JSON.stringify(selection || {}) },
    },
  };
}

// Identifies one settings request, so an answer for a user or selection the
// page has already moved away from can be dropped.
export function notificationSettingsRequestKey(userId, selection) {
  return JSON.stringify({ userId: userId || null, selection: selection || {} });
}

export function fetchNotificationSettings(portal, userId, selection) {
  const params = Object.assign({ portal }, selection);
  if (userId) {
    params.user_id = userId;
  }
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/notification_settings/`,
      types: [
        'FETCH_NOTIFICATION_SETTINGS_REQUEST',
        'FETCH_NOTIFICATION_SETTINGS_SUCCESS',
        'FETCH_NOTIFICATION_SETTINGS_FAIL',
      ],
      params,
      additionalData: { requestKey: notificationSettingsRequestKey(userId, selection) },
    },
  };
}

// `enabled` is true, false, or null to remove a garage/vehicle exception.
export function updateNotificationSetting(portal, userId, selection, targetType, targetId, enabled) {
  const data = Object.assign({
    portal,
    target_type: targetType,
    target_id: targetId,
    enabled,
  }, selection);
  if (userId) {
    data.user_id = userId;
  }
  return {
    [API]: {
      method: PUT,
      url: `${API_URL}/uiapi/1/notification_settings/`,
      types: [
        'UPDATE_NOTIFICATION_SETTING_REQUEST',
        'UPDATE_NOTIFICATION_SETTING_SUCCESS',
        'UPDATE_NOTIFICATION_SETTING_FAIL',
      ],
      data,
      additionalData: { requestKey: notificationSettingsRequestKey(userId, selection) },
    },
  };
}

export function searchNotificationVehicles(portal, userId, organizationId, search) {
  const params = { portal, organization_id: organizationId, search };
  if (userId) {
    params.user_id = userId;
  }
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/notification_settings/vehicles/`,
      types: [
        'SEARCH_NOTIFICATION_VEHICLES_REQUEST',
        'SEARCH_NOTIFICATION_VEHICLES_SUCCESS',
        'SEARCH_NOTIFICATION_VEHICLES_FAIL',
      ],
      params,
      additionalData: { organizationId, search },
    },
  };
}

export function clearNotificationVehicleSearch() {
  return { type: 'CLEAR_NOTIFICATION_VEHICLE_SEARCH' };
}
